export default [
  { label: '', value: '' },
  { label: 'Auto Loan', value: 'autoLoan' },
  { label: 'Credit Card', value: 'creditCard' },
  { label: 'Medical', value: 'medical' },
  { label: 'Mortgage', value: 'mortgage' },
  { label: 'Other', value: 'other' },
  { label: 'Personal Loan', value: 'personalLoan' },
  { label: 'Student Loan', value: 'studentLoan' }
];



// WEBPACK FOOTER //
// ./src/constants/loanTypes.js